import { Link } from "react-router-dom";
import { useLang } from "../App";
import { UI, EXPERIENCE, EDUCATION, PROJECTS } from "../content";

const featuredProjects = PROJECTS.filter((p) => p.featured);

export default function Home() {
  const { lang } = useLang();
  const t = UI[lang];

  return (
    <>
      <div className="main">
        {/* ── Hero ── */}
        <section className="hero">
          <h1 className="hero-title">Adam Elaoumari</h1>
          <p className="hero-subtitle">{t.hero.subtitle}</p>
          <p className="hero-bio">{t.hero.bio}</p>
          <div className="hero-links">
            <a
              href="https://github.com/adamlbs"
              target="_blank"
              rel="noreferrer"
            >
              GitHub ↗
            </a>
            <a
              href="https://linkedin.com/in/adam-elaoumari"
              target="_blank"
              rel="noreferrer"
            >
              LinkedIn ↗
            </a>
            <a href="mailto:adam@admlbs.fr">adam@admlbs.fr</a>
          </div>
        </section>

        {/* ── Experience ── */}
        <section className="section">
          <p className="section-label">{t.labels.experience}</p>
          <div className="entries">
            {EXPERIENCE.map((e) => (
              <div className="entry" key={e.company + e.period}>
                <div className="entry-meta">
                  <p className="entry-period">{e.period}</p>
                  <p className="entry-company">{e.company}</p>
                </div>
                <div>
                  <p className="entry-title">{e.title[lang]}</p>
                  <p className="entry-desc">{e.desc[lang]}</p>
                  {e.tags.length > 0 && (
                    <div className="entry-tags">
                      {e.tags.map((tag) => (
                        <span className="tag" key={tag}>
                          {tag}
                        </span>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* ── Selected Projects ── */}
        <section className="section">
          <p className="section-label">{t.labels.selectedProjects}</p>
          <div className="projects-list">
            {featuredProjects.map((p) => (
              <div
                className="project-row"
                key={p.id}
                style={{ "--project-color": p.color }}
              >
                <div className="project-row-meta">
                  <p className="project-year">
                    {p.year}
                    {p.ongoing ? " →" : ""}
                  </p>
                  <p className="project-primary">{p.primary}</p>
                </div>
                <div className="project-row-content">
                  <div className="project-name-line">
                    {p.github ? (
                      <a
                        className="project-name"
                        href={p.github}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {p.name}
                      </a>
                    ) : p.website ? (
                      <a
                        className="project-name"
                        href={p.website}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {p.name}
                      </a>
                    ) : (
                      <span className="project-name">{p.name}</span>
                    )}
                    {p.stat && (
                      <span className="project-stat">{p.stat[lang]}</span>
                    )}
                    {(p.github || p.website) && (
                      <span className="project-arrow">↗</span>
                    )}{" "}
                  </div>
                  <p className="project-desc">{p.desc[lang]}</p>
                  {p.tags.length > 0 && (
                    <div className="project-tags">
                      {p.tags.map((tag) => (
                        <span className="tag" key={tag}>
                          {tag}
                        </span>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
          <Link to="/projects" className="all-projects-link">
            {t.labels.allProjectsLink}
          </Link>
        </section>

        {/* ── Research ── */}
        <section className="section">
          <p className="section-label">{t.labels.research}</p>
          <div className="pub">
            <div>
              <p className="pub-year">2025</p>
            </div>
            <div>
              <p className="pub-title">{t.research.title}</p>
              <p className="pub-venue">{t.research.venue}</p>
              <p className="pub-desc">{t.research.desc}</p>
            </div>
          </div>
        </section>

        {/* ── Education ── */}
        <section className="section">
          <p className="section-label">{t.labels.education}</p>
          <div className="edu-list">
            {EDUCATION.map((e) => (
              <div className="edu" key={e.school}>
                <div>
                  <p className="edu-period">{e.period}</p>
                </div>
                <div>
                  <p className="edu-school">{e.school}</p>
                  <p className="edu-degree">{e.degree[lang]}</p>
                  <p className="edu-note">{e.note}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* ── Contact ── */}
        <section id="contact" className="section">
          <p className="section-label">{t.labels.contact}</p>
          <p className="contact-line">{t.contact.line}</p>
          <div className="contact-links">
            <div className="contact-item">
              <span className="contact-label">email</span>
              <a href="mailto:adam@admlbs.fr">adam@admlbs.fr</a>
            </div>
            <div className="contact-item">
              <span className="contact-label">github</span>
              <a
                href="https://github.com/adamlbs"
                target="_blank"
                rel="noreferrer"
              >
                github.com/adamlbs
              </a>
            </div>
            <div className="contact-item">
              <span className="contact-label">linkedin</span>
              <a
                href="https://linkedin.com/in/adam-elaoumari"
                target="_blank"
                rel="noreferrer"
              >
                adam-elaoumari
              </a>
            </div>
          </div>
        </section>
      </div>

      <footer className="footer">
        <p className="footer-text">
          Adam Elaoumari · {t.footer} · {new Date().getFullYear()}
        </p>
      </footer>
    </>
  );
}
